module.exports = __webpack_public_path__ + "media/old_images/hexagon-mask-2-335bd38a.png";